import React from 'react';

import {FieldType} from 'src/openapi/models/FieldType';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

import {ConvertorFieldTypeToDataType} from './constants';

import {dataTypesLabel} from './data-types.module.styl';

type Props = {
    dataTypes: FieldType[],
};

export const DataTypes = ({dataTypes}: Props) => {
    return (
        <Group direction="v" gap="xs">
            {dataTypes.map(dataType => (
                <Item key={dataType}>
                    <EllipsisTextHint isActive={false} mix={dataTypesLabel}>
                        {dataType ? ConvertorFieldTypeToDataType[dataType] : ''}
                    </EllipsisTextHint>
                </Item>
            ))}
        </Group>
    );
};
